import useDevice from 'hooks/useDevice';
import React from 'react';
import HeaderResponsive from '../ClientHeader/HeaderResponsive';

export default function LayoutPartner({ isVtStore, isPartnerLink, children }) {
	const { isMobile } = useDevice();
	
	return (
		<div>
			<div className='header-partner'>
				<div className='content-header'>
					<HeaderResponsive
						isPartnerLink={isPartnerLink}
						merchantCode={isVtStore}
						isMoblie={isMobile}
					/>
				</div>
			</div>
			<div className='content-partner'>{children}</div>
		</div>
	);
}
